export enum GlobalActionTypes {
  SNACKBAR_UPDATE = 'SNACKBAR_UPDATE',
  INITIAL_SNACKBAR_SETUP = 'INITIAL_SNACKBAR_SETUP',
  ALERT_OPEN = 'ALERT_OPEN',
  ALERT_CLOSE = 'ALERT_CLOSE',
  LOADING_TO_TRUE = 'LOADING_TRUE',
  LOADING_TO_FALSE = 'LOADING_FALSE',
}
